<template>
    <!-- 时间日期组件 -->
    <div class="vel-date-time">
        <!-- 日期时间组件 -->
        <el-date-picker
        v-if="dateTimeType==='date'"
        v-model="value"
        :type="type"
        :align="align"
        :picker-options="DateTimeOptions || pickerOptions"
        :unlink-panels="unlinkPanels"
        :placeholder="placeholder"
        :prefix-icon="beforeIcon"
        :clear-icon="clearIcon"
        :value-format="valueFormat"
        :range-separator="rangeText"
        :start-placeholder="startText"
        :end-placeholder="endText"
        :readonly="readonly"
        :disabled="disabled"
        :clearable="isClearable"
        :default-time="defaultTime"
        :size="size"
        :format="format"
        :default-value="defaultValue"
        @change="change"
        @focus="focus"
        @blur="blur"
        />
        <!-- 时间范围组件 -->
        <el-time-picker
        v-else-if="dateTimeType==='timePicker'"
        v-model="value"
        :picker-options="DateTimeOptions || pickerOptions"
        :placeholder="placeholder"
        :arrow-control="isCtrl"
        :is-range="true"
        :range-separator="rangeText"
        :start-placeholder="startText"
        :end-placeholder="endText"
        :readonly="readonly"
        :disabled="disabled"
        :clearable="isClearable"
        :size="size"
        :align="align"
        :value-format="valueFormat"
        :prefix-icon="beforeIcon"
        :clear-icon="clearIcon"
        :default-value="defaultValue"
        :format="format"
        :selectableRange="selectableRange"
        @change="change"
        @focus="focus"
        @blur="blur"
        />
        <!-- 时间组件 -->
        <el-time-select
        v-else
        v-model="value"
        :picker-options="DateTimeOptions || pickerOptions"
        :placeholder="placeholder"
        :range-separator="rangeText"
        :start-placeholder="startText"
        :end-placeholder="endText"
        :readonly="readonly"
        :disabled="disabled"
        :clearable="isClearable"
        :size="size"
        :align="align"
        :value-format="valueFormat"
        :prefix-icon="beforeIcon"
        :clear-icon="clearIcon"
        :default-value="defaultValue"
        @change="change"
        @focus="focus"
        @blur="blur"
        />
        
    </div>
</template>
<script>
import {dateOptions, 
datetimerangeOptions, 
datetimeOptions, 
monthrangeOptions, 
daterangeOptions} from  './options'
export default {
    name:"VelDateTime",
    props:{
        initValue:[String,Date,Array],
        DateTimeOptions:Object,
        isCtrl:Boolean,
        placeholder:String,
        rangeText:{
            type:String,
            default:'至'
        },
        startText:{
            type:String,
            default:'开始时间'
        },
        endText:{
            type:String,
            default:'结束时间'
        },
        isClearable:{
            type:Boolean,
            default:true,
        },
        size:String,
        align:String,
        valueFormat:{
            type:String,
            default:'yyyy-MM-dd'
        },
        beforeIcon:String,
        clearIcon:String,
        defaultTime:Array,
        format:String,
        defaultValue:Date,
        selectableRange:[String,Array],
        isWeek:Boolean,
        isMonth:Boolean,
        isYear:Boolean,
        isDates:Boolean,
        isDaterange:Boolean,
        isMonthrange:Boolean,
        isDate:Boolean,
        isTimePicker:Boolean,
        isDateTime:Boolean,
        isDatetimeRange:Boolean,
        isReadonly:Boolean,
        isDisable:Boolean,
        isUnlinkPanels:Boolean,
    },
    data() {
        return {
            value:'',
            type:'',
            dateTimeType:'',
            pickerOptions: null,
            readonly:false,
            disabled:false,
            unlinkPanels:false,
        };
    },
    created() {
        // this.getValue()
        this.getDateType()
        this.initOptions()
    },
    watch:{
        initValue:{
            handler(newval){
                if(!newval) return 
                this.value = newval
            },
            deep:true,
            immediate:true
        }
    },
    methods: {
        initDataFn(){
            this.isReadonly ? this.readonly = true : this.readonly
            this.isDisable ? this.disabled = true : this.disabled
            this.isUnlinkPanels ? this.unlinkPanels = true : this.unlinkPanels
        },
        initOptions(){
            this.type === 'daterange' ? this.pickerOptions = daterangeOptions :
            this.type === 'monthrange' ? this.pickerOptions = monthrangeOptions :
            this.type === 'datetime' ? this.pickerOptions = datetimeOptions :
            this.type === 'datetimerange' ? this.pickerOptions = datetimerangeOptions :
            this.type ==='date' ? this.pickerOptions = dateOptions :
            this.pickerOptions = {}
        },
        getDateType(){
            this.isWeek ? this.type = 'week' :
            this.isMonth ? this.type = 'month' :
            this.isYear ? this.type = 'year' :
            this.isDates ? this.type = 'dates' :
            this.isDaterange ? this.type = 'daterange' :
            this.isMonthrange ? this.type = 'monthrange' :
            this.isDateTime ? this.type = 'datetime' :
            this.isDatetimeRange ? this.type = 'datetimerange' :
            this.type = 'date'

            this.isDate ? this.dateTimeType = 'date' :
            this.isTimePicker ? this.dateTimeType = 'timePicker' : 
            this.dateTimeType = 'time'
        },
        getValue(){
            this.initValue ? this.value = this.initValue :
            this.value = ''
        },
        focus(){
            this.$emit('focus')
        },
        change(val){
            this.$emit('change',val)
        },
        blur(){
            this.$emit('blur')
        },
    }
}
</script>
<style scoped>
.vel-date-time{
    width: 100%;
}
</style>